export default __webpack_public_path__ + "static/media/Animals-18.2d02375d.png";